import { doApi } from './apiClient';
import type { DashboardMessage } from '../types/models/dashboard';

export const apiGetDashboardFeed = (limit = 20): Promise<{ data: DashboardMessage[] }> =>
  doApi<{ data: DashboardMessage[] }>(`api/feed?limit=${limit}`, 'GET');

export const apiPostDashboardMessage = (body: string): Promise<DashboardMessage> =>
  doApi<DashboardMessage>('api/feed', 'POST', { body });

export const apiDeleteDashboardMessage = (id: number): Promise<unknown> =>
  doApi<unknown>(`api/feed/${id}`, 'DELETE');
